import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import PlusIcon from '../../../../components/elements/icons/PlusIcon';  
// import TrashIcon from '../../../../components/elements/icons/TrashIcon';
import AdministrationLayout from '../../../../components/layouts/AdministrationLayout'
import { useDispatch, useSelector } from 'react-redux';
import { fetchHouses } from '../../../../store/actions/housingActions';
import Loader from '../../../../components/elements/Loader';
import EmptyState from '../../../../components/elements/EmptyState';
import ModalDialog from '../../../../components/layouts/ModalDialog'
import NewHouseForm from '../../../../components/partials/houses/NewHouseForm';
import ArrowIcon from '../../../../components/elements/icons/ArrowIcon';
import Pagination from '../../../../components/elements/Pagination';

const Houses = () => {
  const [creatingHouse, setCreatingHouse] = useState(false)
  const dispatch = useDispatch()
  const housingSelector = useSelector(state => state.housing) 

  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(25)
  const [reload, setReload] = useState(0)
  useEffect(() => {
    dispatch(fetchHouses('', page, perPage, reload))  

    if(housingSelector?.createdHouse !== null) {
      setCreatingHouse(false)
    }
    return () => {
      
    };
  }, [page, perPage, dispatch, reload, housingSelector.createdHouse]);

  // const doDeleteHouse = (houseId) => {
  //   if(window.confirm('Are you sure you want to delete this house?')) {
  //       dispatch(deleteHouse(houseId))
  //   }
  // }
  
  return (
    <>
      <AdministrationLayout>
        <div className='w-full'>
          <div className='w-full flex justify-between mb-8'>
            <div className='w-9/12'>
              <h3 className='text-lg font-medium'>Vaatia College Student Housing</h3>
              <p className='text-sm'>Available houses for students in Vaatia College Makurdi.</p>
            </div>
            
            <div>
              <button onClick={()=>{setCreatingHouse(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                <PlusIcon className='w-5 h-5' /> Create a new House
              </button>
            </div>
          </div>

          <div className="w-full">
            {housingSelector?.loadingHouses 
            ? 
              <Loader />
            :
              housingSelector?.houses?.houses?.length > 0 ?
              <>
                <div className='mt-8 mb-5 grid grid-cols-4 gap-2'>
                  {housingSelector?.houses?.houses?.map((house, houseIndex) => (
                    <div key={houseIndex}>
                      <div className='w-full bg-white border border-gray-200'>
                        <div className={`w-full py-4 px-6`}>
                          <div className='flex items-center justify-between'>
                            <h3 className='text-sm font-semibold text-gray-800'>{house.name}</h3>
                            <p className='text-xs text-gray-500 mt-1 capitalize'>{house.gender}</p>
                          </div>

                          <div className='w-full'>
                            <p className='text-xs text-gray-500 mt-2'>House Colors:</p>
                            <div className='flex items-center gap-x-2 mt-2'>
                              {house.colors && house.colors.length > 0 ?
                                house.colors.map((color, colorIndex) => (
                                  <div 
                                    className='flex items-center gap-x-2 py-1 px-2 rounded-full bg-gray-100 border border-gray-200' 
                                     
                                    key={colorIndex}>
                                    <div className='w-2 h-2 rounded-full' style={{backgroundColor: color.hex}} />
                                    <p className='text-xs text-gray-500'>{color.name}</p>
                                  </div>
                                ))
                              :
                                <p className='text-xs text-gray-400'>No colors added</p>
                              }
                            </div>

                            <p className='text-xs text-gray-400 mt-2'>{house?.blocks?.length} blocks, 0 students</p>

                          </div>
                        </div>

                       

                        <div className="w-full flex flex-row-reverse items-center justify-between mt-3 p-4 border-t">
                            <Link to={`/admin/administration/housing/houses/${house._id}`} className='text-[13px] cursor-pointer flex flex-row items-center gap-x-2 text-vcm-purple hover:text-gray-400 transition duration-200'>View/Edit House <ArrowIcon className={`w-4 h-4`} /></Link> 

                            {/* <button onClick={()=>{doDeleteHouse(house._id)}} className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                                <TrashIcon className={`w-5 h-5`} />
                            </button> */}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <Pagination 
                  pagination={{
                    perPage, 
                    page,
                    totalItems: housingSelector.houses.total,
                  }} 
                  changePage={setPage} 
                  updatePerPage={setPerPage}
                />
              </>
            :
              <EmptyState
                emptyStateTitle="No houses found"
                emptyStateText={`No student housing created yet, please click on "Create a new house". above to create one.`}              
              />
            }
          </div>
        </div>

      </AdministrationLayout>

      <ModalDialog
        shown={creatingHouse} 
        closeFunction={()=>{setCreatingHouse(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle='Create new Student Housing'
        maxWidthClass='max-w-lg'
        hideActions={true}
      >
          <NewHouseForm 
            close={()=>{setCreatingHouse(false)}}
            reload={()=>{setReload(reload + 1)}}
          />
      </ModalDialog>
    </>
  )
}

export default Houses